import { NgModule } from '@angular/core';
import { CommonModule, NgOptimizedImage } from '@angular/common';
import { RouterModule } from '@angular/router';
import { CommonPipesModule } from '../common/commonpipes.module';
import { JournalRoutingModule } from './journal-routing.module';
import { FaIconLibrary, FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { NgxTranslateModule } from '../translate/translate.module';
import { JournalHomeComponent } from './journal-home/journal-home.component';
import { JournalVolumeListingComponent } from './journal-volume-listing/journal-volume-listing.component';
import { JournalListingComponent } from './journal-listing/journal-listing.component';
import { fab, faFacebook, faYoutube, faDropbox, faTwitter } from '@fortawesome/free-brands-svg-icons';
import { fas, faUser, faHeart, faList, faCartShopping, faRightLong, faBookmark, faArrowRight, faBuildingColumns, faStar, faStarHalfStroke, faCartPlus } from '@fortawesome/free-solid-svg-icons';
import { far } from '@fortawesome/free-regular-svg-icons';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { ArticleListingComponent } from '../journal/articles/article-listing/article-listing.component';
import { ArticleViewPageComponent } from '../journal/articles/article-view-page/article-view-page.component';
import { ArticleSearchComponent } from './articles/article-search/article-search.component';
import { ArticleSearchListComponent } from './articles/article-search-list/article-search-list.component';
import { ArticlePaginationComponent } from './articles/article-pagination/article-pagination.component';
import { ArticleListComponent } from './articles/article-list/article-list.component';
import { ArticleSectionComponent } from './articles/article-section/article-section.component';
import { ArticleFiltersComponent } from './articles/article-filters/article-filters.component';
import { ToasterDownloadingComponent } from '../common/toaster-downloading/toaster-downloading.component';
import { FaqModule } from '../faq/faq.module';
import { EditorialBoardComponent } from '../editorial-board/editorial-board.component';
import { ViewEditorDetailsComponent } from '../editorial-board/view-editor-details/view-editor-details.component';
import { NgbTooltipModule } from '@ng-bootstrap/ng-bootstrap';
import { ShareModule } from 'ngx-sharebuttons';
import { ShareButtonsModule } from 'ngx-sharebuttons/buttons';
import { ShareIconsModule } from 'ngx-sharebuttons/icons';
import { RenderHtmlDirective } from './articles/article-view-page/render-html.directive';
import { ArticleKeywordFilterComponent } from './articles/article-keyword-filter/article-keyword-filter.component';
import { ArticleKeywordListComponent } from './articles/article-keyword-list/article-keyword-list.component'
import { LoadContentComponent } from './load-content/load-content.component';
import { BreadcrumbNavigationComponent } from '../breadcrumb-navigation/breadcrumb-navigation.component';
import { TruncatePipe } from './articles/article-view-page/truncate.pipe';
import { LazyLoadDirective } from '../template/app-footer/lazy-load.directive';
import { CurrentArticlesComponent } from './current-articles/current-articles.component';
import { VolumeIssueListComponent } from './volume-issue-list/volume-issue-list.component';
import { WordClampDirective } from './word-clamp.directive';

@NgModule({
    declarations: [
        JournalHomeComponent,
        JournalListingComponent,
        JournalVolumeListingComponent,
        ArticleListingComponent,
        ArticleViewPageComponent,
        ArticleSearchComponent,
        ArticleSearchListComponent,
        ArticlePaginationComponent,
        ArticleListComponent,
        ArticleSectionComponent,
        ArticleFiltersComponent,
        ToasterDownloadingComponent,

        EditorialBoardComponent,
        ViewEditorDetailsComponent,
        RenderHtmlDirective,
        ArticleKeywordFilterComponent,
        ArticleKeywordListComponent,
        LoadContentComponent,
        BreadcrumbNavigationComponent,
        TruncatePipe,
        LazyLoadDirective,
        CurrentArticlesComponent,
        VolumeIssueListComponent,
        WordClampDirective
        //  FaqSectionComponent
    ],
    imports: [
        CommonModule,
        FontAwesomeModule,
        NgxTranslateModule,
        RouterModule,
        CommonPipesModule,
        JournalRoutingModule,
        ReactiveFormsModule,
        FaqModule,
        FormsModule,
        NgbTooltipModule,
        ShareModule,
        ShareButtonsModule,
        ShareIconsModule,
        NgOptimizedImage
        //FaqModule
    ],
    exports: [
        ArticleSearchComponent,
        ArticleSearchListComponent,
        ArticleFiltersComponent,
        ReactiveFormsModule,
        LazyLoadDirective
        // BrowserModule,

    ]
})
export class JournalModule {
    constructor(library: FaIconLibrary) {
        library.addIconPacks(fas, far, fab);
        library.addIcons(
            faUser, faHeart, faList, faCartShopping, faFacebook, faYoutube, faDropbox, faTwitter, faRightLong,
            faBookmark, faArrowRight, faBuildingColumns, faStar, faStarHalfStroke, faCartPlus
        );
    }
}
